import { Component, OnInit } from '@angular/core';
import { BrandService } from 'src/app/core/services/brand.service';

@Component({
  selector: 'app-termos-de-uso',
  templateUrl: './termos-de-uso.component.html',
  styleUrls: ['./termos-de-uso.component.scss']
})
export class TermosDeUsoComponent implements OnInit {

    constructor(private brandService: BrandService) { }

  lastUpdate: string = '10/03/2026';
  appName: string = '';
  contactEmail: string = '';
  logoMini: string = '';


  ngOnInit() {
  
      const brand = this.brandService.getBrand();
      this.logoMini = brand.logoMini;
      this.appName = brand.appName;
      this.contactEmail = brand.contactEmail;
    }

}